import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconUnlockLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "icon/unlock-line",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M8 11.3333C8.73334 11.3333 9.33334 10.7333 9.33334 9.99996C9.33334 9.26663 8.73334 8.66663 8 8.66663C7.26667 8.66663 6.66667 9.26663 6.66667 9.99996C6.66667 10.7333 7.26667 11.3333 8 11.3333ZM12 5.33329H11.3333V3.99996C11.3333 2.15996 9.84 0.666626 8 0.666626C6.16 0.666626 4.66667 1.82663 4.66667 3.66663H6C6 2.52663 6.86 1.93329 8 1.93329C9.14 1.93329 10.0667 2.85996 10.0667 3.99996V5.33329H4.00001C3.26667 5.33329 2.66667 5.93329 2.66667 6.66663V13.3333C2.66667 14.0666 3.26667 14.6666 4.00001 14.6666H12C12.7333 14.6666 13.3333 14.0666 13.3333 13.3333V6.66663C13.3333 5.93329 12.7333 5.33329 12 5.33329ZM12 13.3333H4.00001V6.66663H12V13.3333Z",
			fill: "#C0C0C0"
		})
	})
});
export default SvgIconUnlockLine;
